<template>
  <div class="agree-content marketing">
    <br/>
    <p>
      회사가 수집한 상기 개인정보는 상기 보유 및 이용기간 동안 우편(전자우편 포함)발송, 방문, 전화, 카카오톡 메세지 등을 통한 제품설명회 등 보건의료전문가를 대상으로 하는
      마케팅, 시장조사 및 회사의 안내를 포함한 의·약학적 정보 전달 및 취득 활동의 수행 등에 이용될 수 있습니다. 이러한 이용에 동의하지 않는 경우 향후 회사의 제품 안내, 의·약학적 정보 전달이 이루어지지 않을 수 있습니다.
      <br/>
      <br/>
      본인은 상기와 같이 회사의 의·약학적 정보 및 제품 홍보 등 마케팅 정보 동의 수신에 동의합니다.
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
